import React from "react";
import { PartialRoute } from "@irati/utils/history/routing";
import { LangLoader } from "@irati/utils/lang";
import { SETUP_TENANT, ADMIN } from "@irati-web/app/src/routeConfig";
import PartialRoutes from "./PartialRoutes";
var IndexRoute = function (_a) {
    var path = _a.path;
    return (React.createElement(LangLoader, { buckets: [SETUP_TENANT, ADMIN] },
        React.createElement(PartialRoute, { component: PartialRoutes, path: path, componentProps: { path: path } })));
};
export default IndexRoute;
